export const VEHICLE_FIELDS = 'vehicle_fields'
export const TRAVEL_FIELDS = 'travel_fields'
